var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17871 31.7405H31.4321V17.946H34.2592V31.7405H51.5629V35.9635C51.5629 36.2113 51.4182 36.4362 51.1926 36.5388L49.4162 37.347C48.4032 37.8079 47.5801 38.604 47.0858 39.6011C46.6609 40.458 45.7871 41.0001 44.8307 41.0001H10.6446C7.07359 41.0001 4.17871 38.1052 4.17871 34.5342V31.7405Z",
    fill: "#979DAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17871 31.7405H31.4321V17.946H34.2592V37.34H5.99383C4.99137 37.34 4.17871 36.5274 4.17871 35.5249L4.17871 31.7405Z",
    fill: "#514F63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.4369C3 11.6433 3.64331 11 4.43687 11H30.9565C31.75 11 32.3933 11.6433 32.3933 12.4369V34.2377C32.3933 34.8799 31.8727 35.4005 31.2305 35.4005H4.16279C3.5206 35.4005 3 34.8799 3 34.2377V12.4369Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.4369C3 11.6433 3.64331 11 4.43687 11H30.9565C31.75 11 32.3933 11.6433 32.3933 12.4369V34.2377C32.3933 34.8799 31.8727 35.4005 31.2305 35.4005H4.16279C3.5206 35.4005 3 34.8799 3 34.2377V12.4369Z",
    fill: "#67B2FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.35742,
    y: 12.2201,
    width: 4.71472,
    height: 20.7404,
    rx: 2.35736,
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8398,
    y: 12.2201,
    width: 4.71472,
    height: 20.7404,
    rx: 2.35736,
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3223,
    y: 12.2201,
    width: 4.71472,
    height: 20.7404,
    rx: 2.35736,
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8057,
    y: 12.2201,
    width: 4.71472,
    height: 20.7404,
    rx: 2.35736,
    fill: "#CCCCCC"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5723 15.5014C33.5723 14.8592 34.0929 14.3386 34.7351 14.3386H43.2379C44.556 14.3386 45.6574 15.342 45.78 16.6543L45.8773 17.6959C45.9528 18.504 46.1704 19.2924 46.5202 20.0247C47.3963 21.8592 49.0378 23.2131 51.0054 23.7243L51.5344 23.8617C52.2454 24.0464 52.7418 24.6882 52.7418 25.4229V34.1806C52.7418 34.1806 52.3525 35.6043 51.5632 36.3703C50.7738 37.1363 47.6299 38.8325 47.6299 38.8325L44.5206 35.0333C44.0789 34.4936 43.4183 34.1806 42.7209 34.1806H38.8088C37.9441 34.1806 37.1508 34.6604 36.7492 35.4262L35.5173 37.7755C35.3392 38.1152 34.9873 38.328 34.6038 38.328C34.0341 38.328 33.5723 37.8662 33.5723 37.2965V34.1806V15.5014Z",
    fill: "#FFE492"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5723 32.2054C33.5723 31.5674 34.0864 31.0485 34.7244 31.0427L51.8268 30.8859C52.4731 30.88 53.0003 31.4023 53.0003 32.0486V34.1804C53.0003 34.1804 52.6109 35.6042 51.8216 36.3702C51.0322 37.1362 47.6299 38.8323 47.6299 38.8323L44.5206 35.0331C44.0789 34.4934 43.4183 34.1804 42.7209 34.1804H38.8088C37.9441 34.1804 37.1508 34.6602 36.7492 35.426L35.5173 37.7754C35.3392 38.115 34.9873 38.3278 34.6038 38.3278C34.0341 38.3278 33.5723 37.866 33.5723 37.2963V32.2054Z",
    fill: "#FFD863"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4141 17.5302C35.4141 16.888 35.9347 16.3674 36.5769 16.3674H42.7573C43.2907 16.3674 43.7557 16.7303 43.8853 17.2478L44.8304 21.0223C45.0142 21.7563 44.4591 22.4676 43.7025 22.4676H36.5769C35.9347 22.4676 35.4141 21.947 35.4141 21.3048V17.5302Z",
    fill: "#93D3F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 41.5,
    r: 4.5,
    fill: "#E0E0E0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 41.5,
    r: 4.5,
    stroke: "#333333",
    strokeWidth: 1.86047
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 41.5,
    r: 4.5,
    stroke: "#565656",
    strokeWidth: 1.86047
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 41.5,
    r: 4.5,
    fill: "#E0E0E0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 41.5,
    r: 4.5,
    stroke: "#333333",
    strokeWidth: 1.86047
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 41.5,
    r: 4.5,
    stroke: "#565656",
    strokeWidth: 1.86047
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 41.5,
    r: 1.5,
    fill: "#B4B4B4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 41.5,
    r: 1.5,
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck3);
export default __webpack_public_path__ + "static/media/Truck3.d0a3cdeeccd4c962716e4618b5dac07e.svg";
export { ForwardRef as ReactComponent };